export default __webpack_public_path__ + "static/media/HOA-Pavers-Blog.5a1d4aaf.rtf";